const ROLE_SUPERVISOR = 4000;

class User  {
    constructor(user) {
        this.email = user.email;
        this.facebook_id = user.facebook_id;
        this.google_id = user.google_id;
        this.icon = user.icon;
        this.name = user.name;
        this.last_name = user.last_name;
        this.points = user.points;
        this.rank = user.rank;
        this.user_world_id = user.user_world_id;
        this.username = user.username;
        this.level = user.level;
        this.role = user.role;
        this.force_password_change = user.force_password_change;
        this.tokens = user.tokens;
        this.world_completed = user.world_completed;
        this.completed_percentage = user.completed_percentage;
        this.user_chat_is_assistant = user.user_chat_is_assistant;
        this.total_time = user.total_time;
    }

    isSupervisor() {
        return this.role == ROLE_SUPERVISOR;
    }

}